import { graphql, PageProps } from "gatsby";
import { FC } from "react";
import Category from "src/components/Category";

import { CategoryPageContextType } from "./types";

const FifthCategory: FC<
  PageProps<Gatsby.FifthCategoryQuery> & CategoryPageContextType
> = ({
  pageContext: { pageIndex, upperCategories, subCategories, totalPages, pagePath },
  data: { datoCmsFifthCategory, allDatoCmsArticle },
}) => {
  if (!datoCmsFifthCategory || !allDatoCmsArticle) return null;

  return (
    <Category
      articles={[...allDatoCmsArticle.nodes]}
      category={datoCmsFifthCategory}
      categoryTitle={datoCmsFifthCategory.title!}
      pageIndex={pageIndex!}
      path={pagePath!}
      seo={datoCmsFifthCategory.seo!}
      subCategories={subCategories!}
      totalPages={totalPages!}
      upperCategories={upperCategories!}
    />
  );
};

export default FifthCategory;

export const query = graphql`
  query FifthCategory($id: String, $currentCategoryArticles: [String!], $skip: Int!, $limit: Int!) {
    datoCmsFifthCategory(id: { eq: $id }) {
      ...FifthCategoryData
    }
    allDatoCmsArticle(
      filter: { id: { in: $currentCategoryArticles } }
      sort: { fields: meta___firstPublishedAt, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...DatoCmsArticleCard
      }
    }
  }
`;
